// localStorage keys for a moderator's auto-registration, scoped by BOTH event and admin user id.
// Previously these were event-only, so a second admin signing into the same browser would reuse the
// first admin's stored registration/bl-profile token via the validate path — landing on the wrong
// bl_profile. Keying by user.id prevents that cross-admin reuse.
export const moderatorRegKey = (eventUuid: string, userId?: number | string): string =>
	`moderator_reg.${eventUuid}.${userId}`;

export const moderatorBlTokenKey = (eventUuid: string, userId?: number | string): string =>
	`moderator_bl_token.${eventUuid}.${userId}`;
